export enum CellActionTypes {
  CONFIRM = 'CONFIRM',
  REJECT = 'REJECT',
  REMOVE = 'REMOVE',
  ADD = 'ADD',
  SEND_MSG = 'SEND_MSG',
}

export type CellActionTooltipValues = {
  [key: string]: string;
};
